import Pinyin from "js-pinyin";
export default {
  install(Vue, options) {
      // import navbar from '../src/components/content/maintabber/nav_tabar'
      // Vue.component("nav-bar",navbar)
      Array.prototype.distinct = function () {
          var ret = [];
          for (var i = 0; i < this.length; i++) {
              for (var j = i + 1; j < this.length;) {
                  if (this[i] === this[j]) {
                      ret.push(this.splice(j, 1)[0]);
                  } else {
                      j++;
                  }
              }
          }
          return ret;
      }
      //四舍五入保留2位
      Vue.prototype.keepTwoDecimal = function (num) {
          var result = parseFloat(num);
          if (isNaN(result)) {
              return false;
          }
          result = Math.round(num * 100) / 100;
          return result;

      }
      Date.prototype.format = function (fmt) {
          var o = {
              "M+": this.getMonth() + 1,                 //月份 
              "d+": this.getDate(),                    //日 
              "h+": this.getHours(),                   //小时 
              "m+": this.getMinutes(),                 //分 
              "s+": this.getSeconds(),                 //秒 
              "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
              "S": this.getMilliseconds()             //毫秒 
          };
          if (/(y+)/.test(fmt)) {
              fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
          }
          for (var k in o) {
              if (new RegExp("(" + k + ")").test(fmt)) {
                  fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
              }
          }
          return fmt;
      }
      //将金额格式化（n为保留的小数位）
      Number.prototype.fmoney = function (n) {
          if (!n) n = 0;
          let s = this;
          n = n >= 0 && n <= 20 ? n : 2;
          s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
          let l = s.split(".")[0].split("").reverse(),
              r = s.split(".")[1];

          let t = "";
          for (let i = 0; i < l.length; i++) {
              t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
          }
          let res = t.split("").reverse().join("");
          if (r) res += "." + r;
          return res;
      }

      //千位转换
      String.prototype.parseNum = function () {
          var reg = /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g;
          var num = this;
          return String(num).replace(reg, '$&,');
      }
      Date.isLeapYear = function (year) { 
          return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0)); 
      };
      
      Date.getDaysInMonth = function (year, month) {
          return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
      };
      
      Date.prototype.isLeapYear = function () { 
          return Date.isLeapYear(this.getFullYear()); 
      };
      
      Date.prototype.getDaysInMonth = function () { 
          return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
      };
      
      //加减月份
      Date.prototype.addMonths = function (value) {
          var n = this.getDate();
          this.setDate(1);
          this.setMonth(this.getMonth() + value);
          this.setDate(Math.min(n, this.getDaysInMonth()));
          return this;
      };
      String.prototype.translateCity = function () {
        let cityTranslate ={
            香港: "Hong Kong",
            澳门: "Macau",
            西藏: "Tibet",
            中国台湾: "Chinese Taiwan"
        };
        let cityArr = Object.keys(cityTranslate);
        let lang = window.localStorage.getItem("user_lang") || Globals.DefaultLanguage;
        if (lang == 'zh' ) {
            return this;
        } else {
            if (cityArr.some(a=>a == this)) {
                return cityTranslate[this];
            }
            let pinyin = Pinyin.getFullChars(this);
            let head = pinyin.slice(0, 1).toUpperCase();
            let tail = pinyin.slice(1, pinyin.length).toLowerCase();
            return head + tail;
        }
    }
  }
}